import { Observable } from 'rxjs';
import { Map } from 'immutable';

import {
  VolunteerTimeWhereInput,
  VolunteerTimesQuery,
  VolunteerTimesQueryVariables,
  VolunteerTimesDocument,
  MutationApproveVolunteerTimeArgs,
  ApproveVolunteerTimeMutation,
  ApproveVolunteerTimeMutationVariables,
  ApproveVolunteerTimeDocument,
  MutationRejectVolunteerTimeArgs,
  RejectVolunteerTimeMutation,
  RejectVolunteerTimeMutationVariables,
  RejectVolunteerTimeDocument,
} from 'generated/graphql';

import { query, mutate } from '../graphql';

import { addAction, addMultipleAction, removeAction } from './actions';
import VolunteerTime from './model';

export default class VolunteerTimeApi {
  public static getByFilter(
    where: VolunteerTimeWhereInput,
    forceRefetch = false
  ): Observable<{
    type: string;
    volunteerTimes: Map<string, VolunteerTime>;
  }> {
    return Observable.from(
      query<VolunteerTimesQuery, VolunteerTimesQueryVariables>(
        VolunteerTimesDocument,
        { where },
        forceRefetch ? 'network-only' : 'cache-first'
      )
    ).map(({ errors, data }) => {
      if (errors) {
        throw new Error(JSON.stringify(errors));
      }

      return addMultipleAction(
        Map(
          data.volunteerTimes.map((volunteerTime) => [
            new VolunteerTime(volunteerTime).id,
            new VolunteerTime(volunteerTime),
          ])
        )
      );
    });
  }

  static approve(id: MutationApproveVolunteerTimeArgs['id']): Observable<{
    type: string;
    volunteerTime: VolunteerTime;
  }> {
    return Observable.from(
      mutate<ApproveVolunteerTimeMutation, ApproveVolunteerTimeMutationVariables>(
        ApproveVolunteerTimeDocument,
        { id }
      )
    ).map(({ errors, data }) => {
      if (errors) {
        throw new Error(JSON.stringify(errors));
      }

      if (!data) {
        throw new Error('Error approving volunteer time');
      }

      return addAction(new VolunteerTime(data.approveVolunteerTime));
    });
  }

  static deny(id: MutationRejectVolunteerTimeArgs['id']): Observable<{
    type: string;
    id: string;
  }> {
    return Observable.from(
      mutate<RejectVolunteerTimeMutation, RejectVolunteerTimeMutationVariables>(
        RejectVolunteerTimeDocument,
        { id }
      )
    ).map(({ errors }) => {
      if (errors) {
        throw new Error(JSON.stringify(errors));
      }

      return removeAction(id);
    });
  }
}
